import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "sonner";
import { backend, SourceData } from "../../services/backend";
import { UserShortInfo } from "../../types";
import { GroupSelect, ManSelector, SelectInput, Textarea, TextInput } from "../components";

interface ModalCreatorProps {
  onSave: (data: CreateUserCustomerType) => void;
  closeModal: () => void;
}

export const createCustomerSchema = z.object({
  first_name: z.string().min(1, "Имя обязательно"), // Поле "Имя" обязательно
  last_name: z.string().optional(), // Поле "Фамилия" опционально
  phone: z.string().min(6, "Телефон обязателен"),
  source_id: z.string(), // Поле "Источник" опционально
  description: z.string().optional(),
  resonsible_id: z.string().optional(),
});

type CreateUserCustomerType = z.infer<typeof createCustomerSchema>;

const CustomerCreationModal: React.FC<ModalCreatorProps> = ({
  onSave,
  closeModal,
}) => {
  const State = useSelector((state: RootState) => state);
  const [sources, setSources] = useState<SourceData[]>([]);
  const [selectedUserId, setSelectedUser] = useState<number>(0);
  const groupList = State.groupsToSelect;
  const rights = State.rights;
  const [responceUsersToSelect, setUsersToSelect] = useState<UserShortInfo[]>(
    []
  );
  const [selectedGroup, setSelectedGroup] = useState<number>(
    rights.group_ids[0]
  );

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    control,
  } = useForm<CreateUserCustomerType>({
    resolver: zodResolver(createCustomerSchema),
    mode: "onChange", // Включаем валидацию при изменении полей
    defaultValues: {
      first_name: "",
      last_name: "",
      phone: "",
      source_id: "1",
      resonsible_id: "0",
    },
  });

  useEffect(() => {
    backend.getCustomerSources().then((res) => {
      setSources(res.sources);
    });
  }, []);

  useEffect(() => {
    console.log("Shorts:", selectedGroup)
    backend.getAllUsersShorts({ group_id: selectedGroup }).then((res) => {
      setUsersToSelect(res.users);
    });
  }, [selectedGroup])

  const onSubmit = async (data: CreateUserCustomerType) => {
    const isHold = await backend.isPhoneHold(data.phone);
    try {
      const isHold = await backend.isPhoneHold(data.phone);
      if (isHold.hold) {
        toast("Пользователь с таким номером телефона уже существует");
        return;
      }
      await backend.createNewCustomer({
        user_id: 0,
        ...data,
        responsible_id: selectedUserId || 0
      }).then((res) => {
        if (res) {
          const data = res.data;
          if (data.customerId) {
            setTimeout(() => {
               document.location.href = `/client/${data.customerId}`
            }, 1600)
          }
        }
        toast.success("Клиент успешно создан, перенаправляем...");
        onSave(data); // Вызываем callback с данными
      })
      closeModal();
    } catch (error) {
      console.error(error);
      toast.error("Ошибка при создании клиента");
    }
  };

  const groupSelectHandler = (event: any) => {
    const group = Number(event.target.value);
    setSelectedGroup(group);
  }

  return (
    <div className="creationForm">
      <div className="modalHeading">
        <h3>Создание нового клиента</h3>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="columnCenter">
        <TextInput
          label="Имя"
          registration={register("first_name")}
          required
          error={errors.first_name}
        />

        <TextInput
          label="Фамилия"
          registration={register("last_name")}
          error={errors.last_name}
        />

        <TextInput
          label="Телефон"
          registration={register("phone")}
          required
          error={errors.phone}
        />

        <Textarea
          label="Описание"
          registration={register("description")}
          error={errors.description}
        />

        <GroupSelect
          label="Группа"
          groups={groupList}
          value={selectedGroup}
          onChange={setSelectedGroup}
        />

        <ManSelector
          label="Ответственный"
          users={responceUsersToSelect}
          selectedUserId={selectedUserId}
          onChange={setSelectedUser}
        />

        <SelectInput
          label="Источник"
          registration={register("source_id")}
          options={[
            { value: "1", label: "Нет" },
            ...sources.map((source) => ({
              value: String(source.id),
              label: source.name,
            })),
          ]}
          error={errors.source_id}
        />

        <div className="flex between btnRow">
          <button className="filterButton" type="submit">
            Сохранить
          </button>
          <button onClick={closeModal} className="cancelButton" type="button">
            Отменить
          </button>
        </div>
      </form>
    </div>
  );
};

export default CustomerCreationModal;
